import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Sporten met reuma</title>
                <link rel="canonical" href={route("blogs.seventh")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Meer dan 2 miljoen mensen in Nederland hebben last van reuma. Vaak denken mensen dat krachttraining niet mag als je reuma hebt. Dit zou immers slecht zijn voor je gewrichten. De vraag is echter of dit wel juist is."
                />
                <meta
                    property="og:description"
                    content="Meer dan 2 miljoen mensen in Nederland hebben last van reuma. Vaak denken mensen dat krachttraining niet mag als je reuma hebt. Dit zou immers slecht zijn voor je gewrichten. De vraag is echter of dit wel juist is."
                />
                <meta property="og:url" content={route("blogs.seventh")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Sporten met reuma - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/sporten-met-reuma.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/sporten-met-reuma.webp"
                                    type="image/webp"
                                    alt="Sporten met Reuma"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/sporten-met-reuma.jpg"
                                    type="image/jpeg"
                                    alt="Sporten met Reuma"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/sporten-met-reuma.jpg"
                                    alt="Sporten met Reuma"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Sporten met reuma
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Meer dan 2 miljoen mensen in Nederland hebben last van
                        reuma. Vaak denken mensen dat krachttraining niet mag
                        als je reuma hebt. Dit zou immers slecht zijn voor je
                        gewrichten. De vraag is echter of dit wel juist is.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is reuma?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn heel veel verschillende soorten reuma. Reuma is
                        een aandoening waarbij je last hebt van je spieren,
                        botten, pezen en/of gewrichten. Een van de meest
                        voorkomende vorm van reuma is reumatoïde artritis. In
                        2020 zouden er bijna 220.000 mensen in Nederland last
                        hebben van reumatoïde artritis.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Reumatoïde artritis is een vorm van ontstekingsreuma.
                        Hierbij treden er ontstekingen op in de gewrichten.
                        Naast Reumatoïde artritis zijn er nog meerdere vormen
                        van ontstekingsreuma, waarbij ontstekingen kunnen
                        optreden in de gewrichten, spieren, banden en pezen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        De meest voorkomende vorm van reuma in Nederland is
                        artrose. Dit noemen we ook wel slijtagereuma. Dit treedt
                        op als je kraakbeen (deels) verdwenen is. Hierdoor krijg
                        je bot-op-bot contact, wat kan zorgen voor een
                        ontsteking in het gewricht. Meer dan 1,1 miljoen
                        Nederlanders zouden last hebben van artrose.
                    </p>
                    <p className="mt-4 text-gray-100 break-words"></p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Is sporten niet slecht voor reuma?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Dit is wat heel veel mensen denken. Echter is het zo dat
                        uit onderzoek blijkt dat krachttraining juist een
                        positieve werking kan hebben.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Krachttraining heeft namelijk twee voordelen tegen
                        reuma. Ten eerste heeft krachttraining een remmend
                        effect op het verlies van kraakbeen volgens een
                        onderzoek uit 2017[1]. Dit heeft dus een positieve
                        werking bij het tegengaan van artrose.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ten tweede kwam uit het onderzoek naar voren dat
                        krachttraining ook nog eens een ontstekingsremmende
                        werking heeft. Dit heeft dus effect op alle soorten van
                        reuma. Door de ontstekingsremmende werking zorgt
                        krachttraining dus voor pijnverlichting.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Uit ander onderzoek bleek ook nog eens dat
                        krachttraining en andere fysieke activiteiten de
                        stijfheid in de gewrichten verminderen [2]. Daarnaast
                        kwam hierin ook nog voren dat er een positieve werking
                        was op het verminderen van vermoeidheid. Dit is ook van
                        een van de voorkomende symptomen van reuma.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Kan je dan gewoon trainen met reuma?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Ja, je kunt gebruik maken van krachttraining als je
                        reuma hebt. Let hierbij wel op je eigen lichaam. Zoals
                        hierboven heeft krachttraining op verschillende facetten
                        een positief effect op reuma. Dit betekent echter niet
                        dat je maar zo veel en hard mogelijk moet gaan trainen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Het is niet bekend welke intensiteit optimaal is voor
                        deze positieve effecten. Voor nu lijkt een intensiteit
                        tussen 50% en 75% het meest optimale hiervoor. Dit
                        betekent dat je wel krachttraining kunt gebruiken en je
                        je niet hoeft tegen te laten houden door reuma om je
                        droomfysiek te kunnen bereiken.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ervaar je na een tijdje toch meer spierpijn en/of
                        gewrichtspijn? Zorg er dan voor dat je de intensiteit
                        van de training verlaagd, of dat je meer rust neemt na
                        en tussen de trainingen. Reuma komt in vele maten en
                        vormen voor, dus per persoon zal het optimale gebruik
                        van krachttraining verschillen. Luister goed naar je
                        lichaam. Hiermee kun je toch gebruik blijven maken van
                        krachttraining.
                    </p>
                    <p className="mt-4 text-gray-100 italic">
                        [1] Pereira Nunes Pinto, A. C., Natour, J., de Moura
                        Castro, C. H., Eloi, M., & Lombardi Junior, I. (2017).
                        Acute effect of a resistance exercise session on markers
                        of cartilage breakdown and inflammation in women with
                        rheumatoid arthritis. International journal of rheumatic
                        diseases.
                    </p>
                    <p className="mt-4 text-gray-100 italic">
                        [2] Lourenzi, F. M., Jones, A., Pereira, D. F., Santos,
                        J. H. C. A. D., Furtado, R. N. V., & Natour, J. (2017).
                        Effectiveness of an overall progressive resistance
                        strength program for improving the functional capacity
                        of patients with rheumatoid arthritis: a randomized
                        controlled trial. Clinical Rehabilitation,
                        0269215517698732.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
